import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertpopupService {

  /* *
this service is used to open the alert component 
@author suresh 15/10/2025
*/
visible:any=true;
private alertPopupService=new BehaviorSubject({});
getAlertPopup():Observable<any>{
  return this.alertPopupService;
}

showAlertPopup(message:any){
  this.alertPopupService.next(message);
}
  constructor() { }
}
